const BookingBrokerConfig = [
  {
    id: Math.random() * 10,
    name: "Booking_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Date",
        type: "Date",
        isRequired: true,
        validate_key: "Date_Feature",
      },
      {
        id: Math.random() * 10,
        name: "Freight_Type",
        label: "Payment Terms",
        type: "inputdrop",
        dropdowncontent: ["TBB", "Advance 90%", "To Pay"],
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Center_Id",
        label: "Center",
        type: "InputDropForQuery",
        masterName: "LR_Center_Data",
        clearField: "Branch_Code",
        min: 2,
        max: Infinity,
        // disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Booking_No",
        label: "Booking No",
        type: "number",
        disableDependOn: {
          section: "Booking_Details",
          name: "Center_Id",
          disableOn: "Editable",
          disableOnValue: "No",
          value: "",
        },
        min: 1,
        isRequired: true,
        max: Infinity,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Bil_Party",
    fields: [
      {
        id: Math.random() * 10,
        name: "Bill_Consignor",
        label: "Bill Account",
        type: "InputDropForQuery",
        masterName: "SearchUserAccountsForBill",
        clearField: "Branch_Code",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Bill_Consignor_Person",
        label: "Contact Person",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        autoComplete: "off",
        Reference_field: ["Bill_Consignor", "Refered_To"],
        masterName: "AccountContactPerson",

        isSearchable: true,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Material_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Weight_Guarantee",
        label: "Weight Guarantee(MT)",
        type: "number",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Material_Description",
        label: "Material Description",
        type: "text",
        FirstCharCap: true,
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Material_Invoice_No",
        label: "Material Invoice No",
        type: "text",
        AllCaps: true,
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Value",
        label: "Value",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Eway_Bill_Number",
        label: "Eway Bill Number",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Eway_Bill_Expiry_Date",
        label: "Eway Bill Expiry Date",
        type: "Date",
        restrictDateRange: true,
      },
    ],
  },
];

const DeliveryDataConfig = [
  {
    id: Math.random() * 10,
    name: "Mark_Delivery_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Delivery_Date",
        type: "Date",
        isRequired: true,
        validate_key: "Date_Feature",
      },
      {
        id: Math.random() * 10,
        name: "Delivery_Time",
        label: "Delivery Time",
        type: "time",
        dropdowncontent: ["8:00 Am", "8:30 Am", "9:00 Am", "9:30 Am", "9:30 Am"],
        min: 1,
        max: Infinity,
        // isRequired:true,
      },
      {
        id: Math.random() * 10,
        name: "Delivery_Remark",
        setvalue: "Delivery_Remark",
        type: "textarea",
        FirstCharCap: true,
        min: 2,
        max: Infinity,
      },
    ],
  },
];

const VehicleMaterialDetailsConfig = [
  {
    id: Math.random() * 10,
    name: "Location_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "From",
        label: "From City",
        setvalue: "City",
        disable: true,
        FirstCharCap: true,
        isRequired: true,
        type: "InputDropForQuery",
        masterName: "City_Master",
      },
      {
        id: Math.random() * 10,
        name: "From_Area",
        label: "From Area",
        type: "text",
        FirstCharCap: true,
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "To",
        label: "To City",
        setvalue: "City",
        disable: true,
        FirstCharCap: true,
        isRequired: true,
        type: "InputDropForQuery",
        masterName: "City_Master",
      },
      {
        id: Math.random() * 10,
        name: "To_Area",
        label: "To Area",
        type: "text",
        FirstCharCap: true,
        min: 2,
        max: Infinity,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Transporter",
    fields: [
      {
        id: Math.random() * 10,
        name: "Transporter_Account",
        label: "Transporter Account",
        type: "InputDropForQuery",
        masterName: "SearchUserAccountsForTransporter",
        clearField: "Branch_Code",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Transporter_Contact_Person",
        label: "Contact Person",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        autoComplete: "off",
        Reference_field: ["Transporter_Account", "Refered_To"],
        masterName: "AccountContactPerson",
        require: true,
        isSearchable: true,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Vehicle_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Vehicle_No",
        label: "Vehicle",
        placeholder: "Vehicle",
        Reference_field: "Mode",
        AllCaps: true,
        clearField: "Branch_Code",
        type: "InputDropForQuery",
        masterName: "VehicleData",
      },
      {
        id: Math.random() * 10,
        name: "Vehicle_Type",
        label: "Vehicle Type",
        FirstCharCap: true,
        type: "text",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Vehicle_Length",
        label: "Vehicle Length",
        FirstCharCap: true,
        type: "text",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Load_Capacity",
        label: "Load Capacity(MT)",
        FirstCharCap: true,
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Driver_Name",
        label: "Driver Name",
        type: "InputDropForQuery",
        FirstCharCap: true,
        clearField: "Branch_Code",
        masterName: "DriverNameData",
      },
      {
        id: Math.random() * 10,
        name: "Driver_Number",
        label: "Driver Number",
        type: "number",
        min: 10,
        max: 10,
      },
    ],
  },
];

const BillPartyFreightCharges = [
  {
    id: Math.random() * 10,
    name: "Freight_Charges_Transport",
    fields: [
      {
        id: Math.random() * 10,
        name: "Bill_Party_Loading_Weight",
        label: "Loading Weight(MT)",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Bill_Party_Rate",
        label: "Rate",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Bill_Party_Freight_On",
        label: "Freight On",
        type: "inputdrop",
        dropdowncontent: ["Weight", "Fixed"],
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Bill_Party_Freight_Amount",
        label: "Freight Amount",
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Bill_Party_Detention_Loading",
        label: "Detention Loading",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Bill_Party_Detention_Unloading",
        label: "Detention Unloading",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Bill_Party_Hamali_Charge",
        label: "Hamali Charge",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Bill_Party_Sub_Total",
        label: "Sub Total",
        formula: [
          { name: "Bill_Party_Freight_Amount", opt: "+" },
          { name: "Bill_Party_Detention_Loading", opt: "+" },
          { name: "Bill_Party_Detention_Unloading", opt: "+" },
          { name: "Bill_Party_Hamali_Charge", opt: "+" },
        ],
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
    ],
  },
];

const TransporterFreightCharges = [
  {
    id: Math.random() * 10,
    name: "Freight_Charges_Bill",
    fields: [
      {
        id: Math.random() * 10,
        name: "Transporter_Loading_Weight",
        label: "Loading Weight(MT)",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Transporter_Rate",
        label: "Rate",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Transporter_Freight_On",
        label: "Freight On",
        type: "inputdrop",
        dropdowncontent: ["Weight", "Fixed"],
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Transporter_Freight_Amount",
        label: "Freight Amount",
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Transporter_Deduction",
        label: "Deduction",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Transporter_Detention_Loading",
        label: "Detention Loading",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Transporter_Detention_Unloading",
        label: "Detention Unloading",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Transporter_Hamali_Charge",
        label: "Hamali Charge",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Transporter_Sub_Total",
        label: "Sub Total",
        formula: [
          { name: "Transporter_Freight_Amount", opt: "+" },
          { name: "Transporter_Deduction", opt: "-" },
          { name: "Transporter_Detention_Loading", opt: "+" },
          { name: "Transporter_Detention_Unloading", opt: "+" },
          { name: "Transporter_Hamali_Charge", opt: "+" },
        ],
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
    ],
  },
];

const Deliverydocs = [
  {
    id: Math.random() * 10,
    name: "Delivery_POD",
    label: "POD",
  },
];

const docs = [
  {
    id: Math.random() * 10,
    name: "Invoice",
    label: "Invoice",
  },
  {
    id: Math.random() * 10,
    name: "LR",
    label: "LR",
  },
  {
    id: Math.random() * 10,
    name: "Eway_Bill",
    label: "Eway Bill",
  },
  {
    id: Math.random() * 10,
    name: "POD",
    label: "POD",
  },
  {
    id: Math.random() * 10,
    name: "Extra_Doc_1",
    label: "Extra Doc 1",
  },
  {
    id: Math.random() * 10,
    name: "Extra_Doc_2",
    label: "Extra Doc 2",
  },
];

export {
  BookingBrokerConfig,
  BillPartyFreightCharges,
  VehicleMaterialDetailsConfig,
  TransporterFreightCharges,
  docs,
  DeliveryDataConfig,
  Deliverydocs,
};
